<template>
  <vueper-slides fixed-height="700px"
                 autoplay
                 :pause-on-hover="pauseOnHover"
                 :arrows="true"
                 :bullets="false"
  >
    <vueper-slide
        v-for="(slide, i) in slides" :key="i"
        >
      <template #content>
        <div class="hero-containerx">
          <div class="relative bg-cover bg-center pb-24 hero-containerx" :style="{ backgroundImage: 'url(' + slide.background_image.url + ')' }">
            <div class="container mx-auto hero-containerx" style="height: 500px;">
            </div>
          </div>
        </div>
      </template>
    </vueper-slide>
  </vueper-slides>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import 'vueperslides/dist/vueperslides.css';

export default {
    name: "VueperSlidesHomeCarousel",
    components: { VueperSlides, VueperSlide},
    props: {
      slides: {
        type: Array,
        default: [],
        required: false
      }
    },
    methods: {

    }

}
</script>

<style scoped>

</style>